export default __webpack_public_path__ + "57d41122ffcb1776709c3a16b7214941.png";